<template>
  <option-selector
    :title="'releases.old.title' | translate"
    :description="'releases.old.guide' | translate"
    :active="active"
    activeImage="UsePreviousChecked.svg"
    inactiveImage="UsePrevious.svg"
    @selected="onSelected"
  />
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import OptionSelector from './OptionSelector.vue'

@Component({
  components: {
    OptionSelector,
  },
})
export default class OldOptionSelector extends Vue {
  @Prop() public active: boolean

  @Emit('selected')
  public onSelected() {
    return
  }
}
</script>
